import React from 'react';
import { asField } from 'informed';
import { Async } from 'react-select';
import { FormGroup } from 'reactstrap';

const InputSelectAsync = asField(({
  field,
  fieldState,
  fieldApi,
  col,
  label,
  onChange,
  loadOptions,
  multi,
  styleAtividade,
  ...props
}) => {
  const { value } = fieldState;
  const { setValue } = fieldApi;

  return (
    <FormGroup className={col}>
      <label
        style={
          styleAtividade ? {
            color: '#4A4F58',
            fontSize: '14px',
            fontWeight: '500',
            font: 'Public Sans',
            marginBottom: '3px'
          } : {
            fontSize: '14px',
            fontWeight: '500',
            font: 'Public Sans',
            color: '#4A4F58'
          }
        }
      >
        {label}
      </label>
      <Async
        style={
          styleAtividade ? {
            height: '31px',
            borderRadius: '10px',
            border: '1px solid #DED8D8',
            font: 'Public Sans',
            fontSize: '12px',
            background: '#F7F7F7',
            color: '#383838',
          } : {

          }
        }
        onChange={(v) => {
          setValue(v);
          fieldApi.setError(null);
          fieldApi.setTouched();
          if (onChange) onChange(v);
        }}
        loadOptions={loadOptions}
        value={value}
        noResultsText="Nenhum resultado encontrado."
        placeholder="Selecione"
        searchPromptText="Digite para pesquisar..."
        loadingPlaceholder="Carregando..."
        ignoreAccents={false}
        cache={false}
        {...props}
      />
    </FormGroup>
  );
});

InputSelectAsync.defaultProps = {
  placeholder: 'Selecione',
  loadingMessage: () => 'carregando...',
};

export default InputSelectAsync;
